import { kf1Auth } from 'kfone-frontend-core';
import { useTranslation } from 'react-i18next';
import './index.css';

const getInitialName = (name = '') => {
  const nameParts = name.trim().split(/\s+/).filter(Boolean);
  if (nameParts.length === 0) return '';
  const firstInitial = nameParts[0][0].toUpperCase();
  const lastInitial = nameParts.length > 1 ? nameParts[nameParts.length - 1][0].toUpperCase() : '';
  return firstInitial + lastInitial;
};

const LandingPageHeaderContainer = () => {
  const { t } = useTranslation();
  const { keycloakIns } = kf1Auth.useKeycloak();
  const userName =
    keycloakIns?.idTokenParsed?.name?.replace(/\b(undefined|unknown),?\b/gi, '') ?? '';
  const initialName = getInitialName((userName ?? ' ') as string);

  return (
    <div className='landing-page-header-container' data-testid='landing-page-header-container'>
      <span className='header-text' data-testid='header-text'>
        {t('pe.greeting')}{userName || ''}
      </span>
      <span>
        {/* <ODSLink
          id='explore-link'
          text={kf1I18nString('pe.exploreMorePayProductsLinkText')}
          className='explore-link'
          onClick={() => {
            // Add your onClick handler logic here
          }}
        /> */}
      </span>
    </div>
  );
};

export default LandingPageHeaderContainer;
